import CommonApi from "../common/CommonApi";
import axios from "axios";
import SuccessResponse from "../dto/common/SuccessResponse";
import CommonRequestBodyDto from "../dto/common/CommonRequestBodyDto";
import UserListDto from "../dto/user/UserListDto";
import UserInfoDto from "../dto/user/UserInfoDto";
import UserTargetUpdateReqDto from "../dto/user/UserTargetUpdateReqDto";

class RealUserApi extends CommonApi {
    async getUserList({
        page,
        pageSize,
        enabled,
        search,
    }: {
        page: number;
        pageSize: number;
        enabled?: string;
        search?: string;
    }): Promise<SuccessResponse<UserListDto>> {
        const baseHeaders = this.makeBaseHeader();

        const query: Record<string, any> = { page, pageSize };
        if (enabled) query.enabled = enabled;
        if (search) query.search = search;

        await axios.options(`${this.BASE_SERVICE_URL}/users`, {
            headers: baseHeaders,
        });

        const response = await axios.get<SuccessResponse<UserListDto>>(`${this.BASE_SERVICE_URL}/users`, {
            headers: baseHeaders,
            params: query,
        });

        return response.data;
    }

    async getUserInfo(): Promise<SuccessResponse<UserInfoDto>> {
        const baseHeaders = this.makeBaseHeaderWithClientVersion({ xApiVersion: 3.2 });

        await axios.options(`${this.BASE_SERVICE_URL}/users/info`, {
            headers: baseHeaders,
        });

        const response = await axios.get<SuccessResponse<UserInfoDto>>(`${this.BASE_SERVICE_URL}/users/info`, {
            headers: baseHeaders,
        });

        return response.data;
    }

    // 04.01.07.03 유저 정보 수정: PUT /franchises/users/target/info
    // Franchise Admin 이 소속 call_center / store_owner 의 name/phone/enabled 수정
    async updateTargetUserInfo(
        reqDto: CommonRequestBodyDto<UserTargetUpdateReqDto>
    ): Promise<SuccessResponse<Record<string, never>>> {
        const baseHeaders = this.makeBaseHeaderWithClientVersion({ xApiVersion: 3.2 });

        await axios.options(`${this.BASE_SERVICE_URL}/users/target/info`, {
            headers: baseHeaders,
        });

        const response = await axios.put<SuccessResponse<Record<string, never>>>(
            `${this.BASE_SERVICE_URL}/users/target/info`,
            reqDto,
            {
                headers: baseHeaders,
            }
        );

        return response.data;
    }

    // /franchises/users/join/status
    async putFranchiseUser({ franchise_join_status }: { franchise_join_status: string }): Promise<object> {
        const baseHeaders = this.makeBaseHeaderWithClientVersion({ xApiVersion: 3.2 });

        await axios.options(`${this.BASE_SERVICE_URL}/users/join/status`, {
            headers: baseHeaders,
        });

        const response = await axios.put<object>(
            `${this.BASE_SERVICE_URL}/users/join/status`,
            {
                request: {
                    franchise_join_status: franchise_join_status,
                },
            },
            {
                headers: baseHeaders,
            }
        );

        return response.data;
    }
}

export default RealUserApi;
